import { render, staticRenderFns } from "./VerticalHeader.vue?vue&type=template&id=62e57c21"
import script from "./VerticalHeader.vue?vue&type=script&lang=js"
export * from "./VerticalHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports